"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value, params) {
  return value + "\u306F\u6307\u5B9A\u3067\u304D\u306A\u3044\u6587\u5B57\u5217\u3067\u3059";
};